import { useEffect, useState } from 'react';
import { useFaqs } from '../../hooks/useFaqs';

function FaqItem({ item, open, onToggle }) {
  return (
    <div className="border-b border-[#D6E8FF] last:border-b-0">
      <button
        type="button"
        onClick={onToggle}
        aria-expanded={open}
        className="flex w-full items-center justify-between gap-4 py-4 text-left"
      >
        <span className="text-sm font-medium text-[#1B1B1B] sm:text-base">{item.question}</span>
        <span className="shrink-0 text-[#1A87CC]">
          {open ? (
            <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M5 15l7-7 7 7" />
            </svg>
          ) : (
            <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
            </svg>
          )}
        </span>
      </button>
      {open && (
        <p className="pb-4 text-sm leading-relaxed text-[#666666]">{item.answer}</p>
      )}
    </div>
  );
}

function FaqSkeleton() {
  return (
    <div className="space-y-4 py-2">
      {[1, 2, 3, 4].map((n) => (
        <div key={n} className="h-12 animate-pulse rounded-lg bg-[#EAF5FF]" />
      ))}
    </div>
  );
}

export default function TeacherFaqSection() {
  const { faqs, loading, error } = useFaqs();
  const [openId, setOpenId] = useState(null);

  useEffect(() => {
    if (faqs.length && openId === null) {
      setOpenId(faqs[0].id);
    }
  }, [faqs, openId]);

  useEffect(() => {
    if (faqs.length && openId !== null && !faqs.find((item) => item.id === openId)) {
      setOpenId(faqs[0].id);
    }
  }, [faqs, openId]);

  return (
    <section className="bg-[#EAF5FF] px-4 py-12 sm:px-6 lg:px-8 lg:py-16">
      <div className="mx-auto grid max-w-7xl items-start gap-10 lg:grid-cols-2 lg:gap-16">
        <div className="text-center lg:text-left">
          <h2 className="text-2xl font-bold text-[#181059] sm:text-[32px] lg:text-[40px]">
            Frequently Asked Question
          </h2>
          <p className="mt-6 max-w-xl text-sm leading-relaxed text-[#666666] sm:text-base">
            Find clear answers to the most common questions. Everything you need to know about our
            platform in one place.
          </p>
        </div>

        <div className="rounded-2xl bg-white px-5 py-2 shadow-[0_4px_24px_rgba(0,0,0,0.06)] sm:px-6">
          {error && (
            <p className="py-3 text-center text-sm text-red-600">{error}</p>
          )}

          {loading ? (
            <FaqSkeleton />
          ) : faqs.length > 0 ? (
            faqs.map((item) => (
              <FaqItem
                key={item.id}
                item={item}
                open={openId === item.id}
                onToggle={() => setOpenId((current) => (current === item.id ? null : item.id))}
              />
            ))
          ) : (
            <p className="py-6 text-center text-sm text-[#666666]">No FAQs available right now.</p>
          )}
        </div>
      </div>
    </section>
  );
}
